// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__26oUI","consentsList":"PatientConsents_consentsList__2gK08","consentsListEmpty":"PatientConsents_consentsListEmpty__2arnk"};